import { ACTIVITYWAY } from '../utils/constant';
import { queryTemplateDetail } from './api';
export type RouterMatch = {
    activityId?: string;
    productId?: string;
};

/**
 * 获取模板数据
 * @param params 路由上的信息
 */
export const getTemplateInfo = (templateId): Promise<any> =>
    new Promise(async (resolve, reject) => {
        if(!!templateId) {
            const {status,result,info} = await queryTemplateDetail({id:templateId});
            if(!status &&  result){
                console.log(result,'templateRes.result')
                let {templateSurveyVO,templateSecKillVO} = result;
                //数据处理
                // 表单
                if(result.activityWay == ACTIVITYWAY.survey) {
                    let {id,ext,cardDate} = templateSurveyVO || {};
                    templateSurveyVO = {
                        ...templateSurveyVO,
                        templateSurveyId:id,
                        showConfigExt:ext,
                        cardTime:cardDate
                    }
                    delete templateSurveyVO.ext;
                    delete templateSurveyVO.id;
                    resolve(templateSurveyVO)
                } else {
                    let {id,ext,cardDate,courseDetailUrl} = templateSecKillVO || {};
                    templateSecKillVO = {
                        ...templateSecKillVO,
                        templateSecKillId:id,
                        courseDetailUrls:!!courseDetailUrl ? courseDetailUrl.split(',') : courseDetailUrl,
                    //    showConfigExt:ext,
                        cardTime:cardDate
                    }
                //    delete templateSecKillVO.ext;
                    delete templateSecKillVO.id;
                    resolve(templateSecKillVO)
                }
                resolve(result)
            } else {
                reject(info)
            }
        } else {
            reject(null);
        }
        
    });